import React, {useEffect} from 'react';
import Header from '../components/Header';
import '../styles/resultInterpretation.css';

export default function NegativeResult() {

    useEffect(() => {
        document.title = "Interpretation of the Not Detected result"
    }, []);

    return (
        <div className="interpretation">
            <div className="container">
                <div className='main'>
                    <Header/>
                    <p className="heading">Lower risk of having COVID-19</p>
                    <div className="description mt-5">
                        <p>A “lower risk of having COVID-19” result means that the eye scan did not detect changes that may be associated with COVID-19. This result may occur even if you have symptoms consistent with COVID-19. Because this tool does not detect COVID-19 virus material like an FDA-authorized antigen or PCR test, a “lower risk” result does not rule out COVID-19 infection and should not be the only information used to determine participation in social activities or travel. The app does not provide a diagnosis and is not intended to replace FDA-authorized tests or consultation with a healthcare provider.</p>
                        <p>When a “lower risk” result is provided, the possibility of a false result should be considered in the context of 1) the user’s recent exposure to someone with COVID-19 and 2) the presence of symptoms consistent with COVID-19. The possibility of a false result should especially be considered if the user’s recent exposure and/or symptoms are consistent with COVID-19 and diagnostic tests for other respiratory illnesses (for example, flu) are negative.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
